/** A query string with literal commas: `?kurs=a,b` and `?at=46.7,7.7` read and share better than `%2C`. */
export const literalCommas = (params: URLSearchParams): string =>
  params.toString().replace(/%2C/gi, ",");
